import * as React from 'react'
import { Select, Button, Icon } from 'antd'
import { TagModels } from '@getgreenline/tags'
import { Col, Row } from 'antd-v4'
import { OptionProps } from 'antd/lib/select'

interface TagSelectorProps {
  id: string
  tags?: TagModels.ITagContract[]
  defaultValue: string
  isTagSelected?: (tagName: string) => boolean
  setTagStatus?: (tagSelectorId: string, value: string | null | undefined) => void
  updateCreatedTagsContext?: (tagName: string, value: number, callback?: () => void) => void
}

export const TagSelector = (props: TagSelectorProps) => {
  const [selectedTagName, setSelectedTagName] = React.useState(props.defaultValue)
  // Invisible option to create a new tag (shown if the user types in a tag name which doesn't exist)
  const [createTagOption, setCreateTagOption] = React.useState(
    <Select.Option key={-1} value={-1}>
      (Create tag)
    </Select.Option>,
  )
  const [showCreateTagOption, setShowCreateTagOption] = React.useState(false)
  // Tags which exist within the company
  const existingNonDuplicateTags = props.tags?.filter(
    (tag) => !tag.deleteDate && !props.isTagSelected?.(tag.name),
  )
  const deleteSelf = () => {
    props?.updateCreatedTagsContext?.(selectedTagName, -1)
    props.setTagStatus?.(props.id, undefined)
  }
  const tagToSelectOption = (tag: TagModels.ITagContract) => (
    <Select.Option key={tag.id} value={tag.name}>
      {tag.name}
    </Select.Option>
  )
  const selectPlaceholder = 'Search'
  const selectDefaultValue = props.defaultValue || undefined
  const selectOnChange = (value: string) => {
    if (props.setTagStatus) {
      props?.updateCreatedTagsContext?.(selectedTagName, -1, () =>
        props?.updateCreatedTagsContext?.(value, 1),
      )
      props.setTagStatus(props.id, value)
      setSelectedTagName(value)
    }
    if (value === createTagOption.props.value) {
      setShowCreateTagOption(false)
    }
  }
  const selectOnSearch = (value: string) => {
    const parsedValue = value.trim().toLowerCase()
    const showOption = parsedValue?.length > 1 && !props.isTagSelected?.(parsedValue)
    setShowCreateTagOption(showOption)

    if (showOption) {
      setCreateTagOption(
        <Select.Option {...createTagOption.props} value={parsedValue}>
          {parsedValue} <b>(Create Tag)</b>
        </Select.Option>,
      )
      for (const tag of existingNonDuplicateTags || []) {
        const tagContainsSearchText = tag.name.toLowerCase() === parsedValue

        if (tagContainsSearchText) {
          setShowCreateTagOption(false)
          break
        }
      }
    }
  }
  const selectFilterPredicate: (
    inputValue: string,
    option: React.ReactElement<OptionProps>,
  ) => boolean = (input, option) =>
    option.key === createTagOption?.key ||
    (option.props.children?.toString()?.toLowerCase().includes(input.toLowerCase()) ?? false)
  return (
    <Row
      style={{
        paddingBottom: 20,
        display: 'flex',
        alignItems: 'center',
      }}
    >
      <Col span={2}>
        <b>Tag</b>
      </Col>
      <Col style={{ paddingLeft: 5, paddingRight: 10 }} span={19}>
        <Select<string>
          style={{ fontSize: '13px' }}
          placeholder={selectPlaceholder}
          defaultValue={selectDefaultValue}
          optionLabelProp='value'
          showSearch
          className='w-100'
          size='large'
          onChange={selectOnChange}
          onSearch={selectOnSearch}
          filterOption={selectFilterPredicate}
          allowClear={false}
          getPopupContainer={() => document.body}
        >
          {showCreateTagOption ? createTagOption : null}
          {existingNonDuplicateTags?.map(tagToSelectOption)}
        </Select>
      </Col>
      <Col span={2}>
        <Button type='ghost' onClick={deleteSelf} style={{ border: 'none', background: 'none' }}>
          <Icon type='delete' theme='filled' />
        </Button>
      </Col>
    </Row>
  )
}
